module.exports = __webpack_public_path__ + "img/showMenu.2bcc3a2d.svg";